var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoMaquina(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "dhs3d8syea"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.662745 0 0 0 0 0.992157 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#0196e0",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18.046c0 .803-.68 1.454-1.518 1.454H3.019c-.839 0-1.519-.651-1.519-1.454V6.704c0-.803.68-1.454 1.519-1.454h17.963c.838 0 1.518.65 1.518 1.454v11.342z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12.375a4.875 4.875 0 1 1-9.75 0 4.875 4.875 0 0 1 9.75 0zM17.25 9.75h3V7.5h-3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoMaquina);
export default __webpack_public_path__ + "static/media/PictoMaquina.6533ae435dd4bda01b4d373afd2dfacb.svg";
export { ForwardRef as ReactComponent };